// TODO: refactor and optimize this class!
class FavoritesFilter {
    constructor(el, opts) {
        if (!el) {
            console.error('FilterForm class constructor requires "el" argument!');
            return;
        }

        restoreFilterFormInputs();

        const submitHandler = _.debounce(opts.submitHandler, 700);

        let $filterForm = $(el);
        let flatsMobileSorter   = $('[data-sort-flats-select]');
        let typicalMobileSorter = $('[data-sort-typicals-select]');

        if (!$filterForm.length) {
            console.error('FilterForm constructor can\'t find given "el" in DOM!');
            return;
        }

        if ( flatsMobileSorter.length ) {
            new SlimSelect({
                select: flatsMobileSorter[0],
                showSearch: false
            });
        }

        if ( typicalMobileSorter.length ) {
            new SlimSelect({
                select: typicalMobileSorter[0],
                showSearch: false
            });
        }

        let $inputs = $($filterForm.get(0).elements);

        $inputs.on("change", event => {
            event.preventDefault();
            $inputs.blur();
            $filterForm.trigger("submit");
        });

        $filterForm
            .on("submit", event => {
                event.preventDefault();
                submitHandler($filterForm);
                return false;
            })
            .trigger("submit");


        this.$filterForm = $filterForm;
        this.$inputs = $inputs;
        this.tooltips = null;
    }

    resetFilterForm() {
        this.$filterForm[0].reset();
        this.rangeSliders.forEach(rangeSliderInst => {
            let min = rangeSliderInst.noUiSlider.options.range.min;
            let max = rangeSliderInst.noUiSlider.options.range.max;
            rangeSliderInst.noUiSlider.set([min, max]);
        });

        this.multycheckboxes.forEach(multiCheckboxInst => {
            multiCheckboxInst.reset();
        });
    }

    /*save() {

    }

    restore() {

    }*/
}
